/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import config from '../config/appCardList.config.json';
import axios from 'axios';
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { GET_SUPPLY_CHAIN_LIST } from '../graphql';
import { VApplication } from '@/application';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { BreadcrumbService } from '../../../../services/breadcrumbService';

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.GraphqlServerModule') as GraphqlServerModule;
};

export interface IGetHolderGroupProps {
  offset?: number;
  size?: number;
  where?: any;
}

export interface IAppCardListMethods extends IPluginMethodMap {
  getAppCardListProps(args: any): Promise<any>;
}
const getBreadcrumbService = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.BreadcrumbService') as BreadcrumbService;
};

export class AppCardListService implements IAgentPlugin {
  readonly methods: IAppCardListMethods;

  constructor() {
    this.methods = {
      getAppCardListProps: this.getAppCardListProps.bind(this),
    };
  }

  async getAppCardListProps(args: any) {
    let organizationId: string;
    const srv = getBreadcrumbService();
    const breadcrumbItems = srv?.getBreadCrumbItems();
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient('graphql-gateway');
    const storageService = StorageModule?.getInstance();
    const orgDetails = storageService?.get('myProfile', 'local')?.orgData;
    organizationId = orgDetails?.id;

    // try {
    //   if (client) {
    //     const res = await client.query({
    //       query: GET_SUPPLY_CHAIN_LIST,
    //       variables: {
    //         where: {
    //           entitledSuppliers_SINGLE: {
    //             id: organizationId,
    //           },
    //         },
    //       },
    //       fetchPolicy: 'network-only',
    //     });
    //     if (res?.data?.supplyChainSteps) {
    //       let _templateData = this.formatHolderGroup(
    //         res?.data?.supplyChainSteps
    //       );
    //       return {
    //         appCardList: _templateData,
    //         isEmpty: res?.data?.supplyChainSteps?.length <= 0,
    //         activePage: res?.data?.supplyChainSteps?.currentPage,
    //         pageSize: res?.data?.supplyChainSteps?.pageSize,
    //         totalCount: res?.data?.supplyChainSteps?.totalCount,
    //         totalPages: res?.data?.supplyChainSteps?.totalPages,
    //       };
    //     }
    //   }
    // } catch (err: any) {
    //   throw err;
    // }
    // return {
    //   config: { ...config, ...(breadcrumbItems || {}) },
    // };
    return { ...(config || {}) };
  }

  private formatHolderGroup(data: any) {
    console.log('formatHolderGroup =>', data);
    let _appCard = data.map((item: any) => {
      return {
        ...item,
        appCardId: item?.id,
        appCardImage: item?.icon,
        appCardTitle: item?.traceOutput,
        appCardDescription: item?.description,
      };
    });

    return _appCard;
  }
}
